import { Col, Container, Flex } from '@/ui';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { Outlet } from 'react-router';
import { AppSideBar } from '@/components';
import React, { useState } from 'react';
import { Header } from '@/layouts/components';

export const AdminLayout = () => {
  const { userRole } = useSelector((state) => state.user);
  const [menuVisible, setMenuVisible] = useState(false);

  const openMenu = () => {
    setMenuVisible(true);
  };

  const closeMenu = () => {
    setMenuVisible(false);
  };

  if (userRole) {
    return (
      <StyledContainer>
        <Flex wrap={'nowrap'}>
          <Header routerMode='admin' />

          <StyledSideBar>
            <AppSideBar
              userRole={userRole}
              menuVisible={menuVisible}
              openMenu={openMenu}
              closeMenu={closeMenu}
            />
          </StyledSideBar>

          <StyledMainBlock $wide>
            <Outlet />
          </StyledMainBlock>
        </Flex>
      </StyledContainer>
    );
  }

  return null;
};

const StyledContainer = styled.div`
  min-height: 100vh;
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const StyledSideBar = styled(Container)`
  flex: 0 0 20%;
`;
const StyledMainBlock = styled(Container)`
  position: relative;
  box-sizing: border-box;
  padding: 0 20px;
  margin-top: 70px;
  width: unset;
  flex: 1 1 auto;
  min-width: 0;
`;
